export default __webpack_public_path__ + "static/media/snow-landing.48738755.png";